export const H5_VIEWPORT_MIN_WIDTH = 760;

const MOBILE_BROWSER_PATTERN = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i;

export interface ClientEnvironment {
  readonly viewportWidth: number;
  readonly userAgent: string;
  readonly platform?: string;
  readonly maxTouchPoints?: number;
}

export function isMobileBrowser({ userAgent, platform = "", maxTouchPoints = 0 }: Pick<ClientEnvironment, "userAgent" | "platform" | "maxTouchPoints">): boolean {
  const isIPadDesktopMode = platform === "MacIntel" && maxTouchPoints > 1;
  return MOBILE_BROWSER_PATTERN.test(userAgent) || isIPadDesktopMode;
}

export function shouldUseH5Client(environment: ClientEnvironment): boolean {
  return environment.viewportWidth < H5_VIEWPORT_MIN_WIDTH || isMobileBrowser(environment);
}

export function normalizeMobileRoute(pathname: string): string {
  const prefixedPath = pathname.match(/^\/(?:website|pc)(?=\/|$)(.*)$/i);
  if (!prefixedPath) return pathname || "/";
  return prefixedPath[1] || "/";
}
